module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_7005.11abfa94.png";